/*
 * company_dashboards.js — esbuild IIFE entry
 * Migrated from app/assets/javascripts/company_dashboards.js
 */
window.CompanyDashboards = {
    VisitorsGrid: {
        _gridApi: null,

        selector() { return '#visitors-grid'; },
        element() { return $(this.selector()); },
        dataUrl() { return this.element().data('url'); },
        visitor() { return this.element().data('visitor'); },

        _setRowData(visitor) {
            $.ajax({
                url: this.dataUrl(),
                dataType: 'json',
                data: { visitor },
                success: (data) => {
                    this._gridApi.setGridOption('rowData', data.visitors);
                    this._gridApi.sizeColumnsToFit();
                    resizeAgGridTable(this.selector(), { api: this._gridApi }, 0, data.visitors.length);
                }
            });
        },

        initialize() {
            if (!this.element().length) { return; }
            const gridOptions = {
                rowData: null,
                headerHeight: 44,
                rowHeight: 44,
                columnDefs: [
                    { headerName: I18n.t('company_dashboards.index.visitor'), field: 'visitor_name', cellClass: 'bold' },
                    { headerName: I18n.t('company_dashboards.index.company'), field: 'company_name' },
                    { headerName: I18n.t('company_dashboards.index.page'), field: 'page_visited' },
                    { headerName: I18n.t('company_dashboards.index.date'), field: 'date' }
                ],
                onGridReady: () => this._gridApi.sizeColumnsToFit(),
                onGridSizeChanged: () => this._gridApi.sizeColumnsToFit()
            };
            this._gridApi = agGrid.createGrid(this.element()[0], gridOptions);
            this._setRowData(this.visitor());
            $(window).resize(() => this._gridApi.sizeColumnsToFit());
        }
    }
};
